import questionType from "./questionType";
export default {
  namespaced: true,
  state: {},
  actions: {
    // 添加问卷题目
    addExam({ state }, type) {
      const queston_type = questionType.state.queston_type;
      switch (type) {
        case queston_type.SCQ:
          return {
            type: queston_type.SCQ,
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                  jump_title: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                  isCorrect: false,
                },
              ],
              count: 1, //单选多选
            }),
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题 5详情页显示答案
          };
        case queston_type.MCQ:
          return {
            type: queston_type.MCQ,
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  isCorrect: false,
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  isCorrect: false,
                },
              ],
              maxCount: 1,
              minCount: 1,
            }),
            status: "0",
          };
        case queston_type.SBQ:
          return {
            type: queston_type.SBQ,
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            fillSymbol: 3, // 填空符数量
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseAnswer: "", // 正确答案
            scoringMethod: 0, // 评分方式
            status: "0",
          };
        case queston_type.MBQ:
          return {
            type: queston_type.MBQ, // 多项填空
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  img_path: [],
                  correct_answer: "",
                },
                {
                  text: "",
                  img_path: [],
                  correct_answer: "",
                },
                {
                  text: "",
                  img_path: [],
                  correct_answer: "",
                },
              ],
            }),
            scoringMethod: 0, // 评分方式
            status: "0",
          };
        case queston_type.QA:
          // 问答
          return {
            type: queston_type.QA, // 分数评定类型
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseAnswer: "", // 正确答案
            keyword: "", // 关键词
            scoringMethod: 0, // 评分方式
            status: "0",
          };
        case queston_type.TFQ:
          // 判断题
          return {
            type: queston_type.TFQ,
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "正确",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                  jump_title: "",
                  isCorrect: false,
                },
                {
                  text: "错误",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                  isCorrect: false,
                },
              ],
              count: 1, //单选多选
            }),
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          };
        case queston_type.IMAGE:
          // 图片
          return {
            type: queston_type.IMAGE, // 图片上传类型
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            pictureNum: 6, // 图片数量
            status: "0",
          };
        case queston_type.ClozeTest:
          return {
            type: queston_type.ClozeTest,
            questionScore: 0, // 分数
            analysis: "", // 解析
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            fillSymbol: 3, // 填空符数量
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseAnswer: "", // 正确答案
            scoringMethod: 0, // 评分方式
            status: "0",
          };
        case queston_type.NAME:
          return {
            type: queston_type.NAME, // 姓名
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.GENDER:
          return {
            type: queston_type.GENDER, // 性别
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "男",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "女",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          };
        case queston_type.AGE:
          return {
            type: queston_type.AGE, // 年龄
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "18岁以下",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "18~35岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "35~60岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "60岁以上",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          };
        case queston_type.TEL:
          return {
            type: queston_type.TEL, // 手机号
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            isOnly: 0, // 0 是否唯一  0否 1是
            status: "0",
          };
        case queston_type.EMAIL:
          return {
            type: queston_type.EMAIL, // 邮箱
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.DATE:
          return {
            type: queston_type.DATE, // 日期
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.TIME:
          return {
            type: queston_type.TIME, // 时间
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.ADDR:
          return {
            type: queston_type.ADDR, // 地址类型
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            mapAccuracy: 3, // 0 选择地址精度 1 精确到省 2 精确到市 3 精确到区 4 精确到详细地址
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            status: "0",
          };
        case queston_type.BDQ:
          return {
            type: queston_type.BDQ, // 出生日期
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.IDQ:
          return {
            type: queston_type.IDQ, // 身份证号
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.ELQ:
          return {
            type: queston_type.ELQ, // 学历
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "初中及以下",
                },
                {
                  text: "高中/中专/技校",
                },
                {
                  text: "大学专科",
                },
                {
                  text: "大学本科",
                },
                {
                  text: "硕士及以上",
                },
              ],
            }),
            status: "0",
          };
        case queston_type.WX:
          return {
            type: queston_type.WX, // 微信号
            caseProblem: "", // 题目
            questionScore: 0, // 分数
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.Customize:
          return {
            type: queston_type.Customize, // 自定义
            questionScore: 0, // 分数
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        default:
          return {};
      }
    },
  },
  getters: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/moduleExam.js